import { render, staticRenderFns } from "./YA_ExploreBot.vue?vue&type=template&id=18609e77&scoped=true"
import script from "./YA_ExploreBot.vue?vue&type=script&lang=js"
export * from "./YA_ExploreBot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18609e77",
  null
  
)

export default component.exports